import React from 'react';

const Button = ({
  isSecondary,
  isMobile,
  onClick = undefined,
  href = undefined,
  label
}) => {
  return (
    <a
      className={`
       ${isMobile ? 'detail-row__btn--sm' : 'detail-row__btn'}
       ${
         isSecondary ? 'detail-row__btn__border' : 'detail-row__btn__bg'
       } text-center py-3`}
      onClick={onClick}
      href={href}
    >
      {label}
    </a>
  );
};

export default Button;
